import ModelEntity from "../model-entity"
import ModelProxy from "../model-proxy"

import {GoalType, RenderDisplay} from "./const"
import GoalsCollection from "./collection"
import {toMomentDate} from "../../gd/convert/moment-date"
import {toYYYYMMDD} from "../../gd/convert/to-yyyymmdd"
import {EntityType} from "../../gd/const/item"
import FieldProto from "../../fields3/proto/field-proto"
import FieldsFactory from "../../fields3/fields-factory"
import {FieldType} from "../../fields3/field-type"
import ErrorProto from "../../gd/validation/error"
import ErrorFieldRequired from "../../gd/validation/error-field-required"
import ApiGoal from "../../gd/api/goal"
import {RAG_NOT_SET} from "../../fields3/generic/rag/rag"
import Moment from "moment/moment"
import DatetimeUtils from "../../gd/utils/datetime-utils"
import {Cover} from "../task/properties/cover"
import GoalMessagesCollection from "./messages/collection"
import {momentRange} from "../../gd/convert/moment-range"
import setGoalDuration from "./actions/set-duration"
import {WorkdayStretchType} from "../../gd/workday/workday"
import {GoalProperties} from "./properties/properties"
import GoalUsersCollection from "./user/collection"
import GoalAccessControl from "./access-control/access-control"
import AttachmentsCollection from "../attachment/attachments"
import Message from "../message/message"

const debug = false
// const debug = "Goal"

export default class Goal extends ModelEntity {

    private _name               : string
    private _icon?              : string
    private _color              : number

    // public sortPosition         : number

    private _users              : GoalUsersCollection
    private _assigneeUserIds    : ID[] | null
    public ownerUserIds         : ID[]
    public projectId            : ID

    public momentCreated        : Moment | null
    private _startDate          : MomentDate | null
    private _endDate            : MomentDate | null


    // public status               : GoalStatus     // tut eche nado podumat'.... sil'no vozmozno eto SystemStatus
    private _health             : number            // RAG
    private _type               : GoalType          // checkbox, task, etc...
    public entityId?            : ID                // for GoalType.TASK, GoalType.PROJECT, GoalType.EVENT

    private _currentValue?      : number
    public targetValue?         : number

    private _totalProgress      : number    = 0

    public rootGoalId           : ID
    public rootGoal!            : Goal
    public parentGoalId?        : ID
    public parentGoal?          : Goal

    public subGoals             : GoalsCollection = new GoalsCollection()

    public descriptionRTF?      : JSONObject
    public description?         : string
    public externalLink?        : any

    public properties           : GoalProperties | null    // json to store other data

    public messages             : GoalMessagesCollection

    public isDeleted            : boolean
    public isArchived           : boolean

    // render properties
    public render           : {
        display: RenderDisplay
    }

    constructor(data: any, useProxy = true) {
        super(data['id'], EntityType.GOAL)

        this._name              = data.name
        this._icon              = _.get(data, 'icon', undefined)
        this._color              = _.get(data, 'color', 17)

        this.sortPosition       = _.get(data, 'sortPosition', 0)

        const assigneeUserIds: ID[] | null = _.compact(data.assigneeUserIds)
        this._assigneeUserIds   = _.isEmpty(assigneeUserIds) ? null : assigneeUserIds

        this._users             = GoalUsersCollection.initFromJSON(data.users)
        this.ownerUserIds       = data.ownerUserIds
        this.momentCreated      = DatetimeUtils.datetimeToMoment(data.momentCreated)
        this._startDate         = toMomentDate(data.startDate)
        this._endDate           = toMomentDate(data.endDate)
        this.projectId          = data.projectId
        this._type              = _.get(data, "type", GoalType.CHECKBOX)
        this.properties         = new GoalProperties(data.properties)    // json to store other data
        this.isDeleted          = _.get(data, 'isDeleted', false)
        this.isArchived         = _.get(data, 'isArchived', false)

        // this.status             = _.get(data, "status", GoalStatus.NOT_STARTED)              // Goal Status.... Progress at Risk completed
        this._health            = _.get(data, "health", RAG_NOT_SET)

        this._currentValue      = data.currentValue
        this.targetValue        = data.targetValue

        this.descriptionRTF     = data.descriptionRTF
        this.description        = data.description
        this.externalLink       = data.externalLink
        this.rootGoalId         = data.rootGoalId
        this.parentGoalId       = data.parentGoalId

        this.messages           = GoalMessagesCollection.initFromJson(data.messages)
        this.messages.setGoal(this)
        this.messages.update()

        // init subGoals collections (is filled in GoalsCollection by initParentsAndChildren)
        // this.subGoals           = GoalsCollection.initFromJson(data.subGoals)

        this.entityId           = _.get(data, 'entityId', undefined)

        this.render             = {
            display: RenderDisplay.VISIBLE
        }

        return useProxy ? new Proxy(this, ModelProxy) : this
    }

    openGoal() {
        gd.navigation.goToGoal(this.id)
    }

    get acl():GoalAccessControl {
        return new GoalAccessControl(this)
    }

    get isSubGoal() {
        return this.id !== this.rootGoalId
    }

    get name(): string {
        return this._name
    }

    set name(value: string) {
        this._name = value
    }

    get type(): GoalType {
        switch (this._type) {
            case GoalType.PROJECT   :
            case GoalType.TASK      :
            case GoalType.EVENT     :
                return this._type

            default                 :
                return this.hasSubGoals ? GoalType.PARENT_GOAL : this._type
        }
    }

    set type(value: GoalType) {
        this._type = value;
    }

    // get iconWithColor(): any {
    //     return {
    //         icon    : this.icon,
    //         color   : this.color
    //     }
    // }

    // set iconWithColor(data: {icon?:string, color?:number}) {
    //     if (data.icon !== undefined)    this._icon = data.icon
    //     if (data.color !== undefined)   this.color = _.get(data, 'color', 17)
    // }

    get icon():string {
        if (this._icon) return this._icon

        switch (this.type) {
            case GoalType.CHECKBOX      : return 'target'
            case GoalType.COUNTER       : return 'numbers'
            case GoalType.CURRENCY      : return 'money'
            case GoalType.PERCENT       : return 'percent'

            case GoalType.PARENT_GOAL   :
            default                     : return 'ii5-trophy'
        }
    }

    set icon(icon: string) {
        this._icon = icon
    }

    get color(): number {
        return this._color
    }

    set color(value: number) {
        this._color = value
    }


    get startDate(): MomentDate | null {
        return this._startDate
    }

    set startDate(value: MomentDate | null) {
        const startDate = value
        let endDate

        debug && console.log(debug, 'startDate', value)

        if (startDate && (!this.endDate || startDate?.isAfter(this.endDate, 'day'))) {
            endDate = startDate.clone() as MomentDate
        }
        if (!startDate) {
            endDate = null
        }

        this._startDate = startDate
        this.updatedFields.add('startDate')

        if (!_.isUndefined(endDate)) {
            this._endDate = endDate
            this.updatedFields.add('endDate')
        }
    }

    get endDate(): MomentDate | null {
        return this._endDate
    }

    set endDate(value: MomentDate | null) {
        const endDate = value
        let startDate

        debug && console.log(debug, 'endDate', value)

        if (this.startDate && endDate?.isBefore(this.startDate, 'day')) {
            startDate = endDate.clone() as MomentDate
        }
        if (!endDate) {
            startDate = null
        }

        this._endDate = endDate
        this.updatedFields.add('endDate')

        if (!_.isUndefined(startDate)) {
            this._startDate = startDate
            this.updatedFields.add('startDate')
        }
    }

    get startDue(): {start: Moment | null, end: Moment | null} | undefined {
        if (!this.startDate && !this.endDate) return undefined
        return {
            start   : this.startDate,
            end     : this.endDate
        }
    }

    get users(): GoalUsersCollection {
        return this.isRoot ? this._users : this.rootGoal!.users
    }

    set users(value: GoalUsersCollection) {
        if (this.isRoot) {
            this._users = value
        } else {
            this.rootGoal.users = value
        }
    }

    get userIds() {
        return _.map(this.users.models, u=>u.userId)
    }

    // is required for duration calculations
    get userId(): ID | null {
        return this.userIds[0]
    }

    get assigneeUserIds(): ID[] | null {
        return this._assigneeUserIds
    }

    set assigneeUserIds(values: ID[] | null) {
        this._assigneeUserIds = values
    }

    get duration():number | null {
        if (!!this.startDate && !!this.endDate) {
            const workdays = gd.utils.numberOfWeekdaysBetween(this.startDate, this.endDate)
            if (workdays !== 0) return workdays
        }

        return null
    }

    set duration(value:number | null) {
        debug && console.log(debug, 'duration', value)

        setGoalDuration(this, value, WorkdayStretchType.INCLUDE_HOLIDAYS)
    }

    get durationWorkdays():number | null {

        // if (!this.startDate || !this.endDate) return null

        if (!!this.startDate && !!this.endDate) {
            const workSchedule = this.userId ? gd.workSchedule.getUserWorkSchedule(this.userId) : gd.workSchedule.getCompanyWorkSchedule()
            const workdays = workSchedule.calculateWorkdays(momentRange(this.startDate, this.endDate))
            if (workdays !== 0) return workdays
        }

        return null
    }

    set durationWorkdays(value:number | null) {
        setGoalDuration(this, value, WorkdayStretchType.EXCLUDE_HOLIDAYS)
    }

    get currentValue(): number {
        return this._currentValue || 0
    }

    set currentValue(value: number | undefined) {
        this._currentValue = value
    }

    get totalProgress(): number {
        return this._totalProgress // is filled by calculateTotalProgress
    }

    calculateTotalProgress() {
        let res
        if (!this.subGoals.isEmpty) {
            res = this.subGoals.calculateTotalProgress()
        } else {
            res = this.progress
        }

        debug && console.log(debug, 'calculateTotalProgress', this._name, this.type, res, this.currentValue, this.targetValue)

        this._totalProgress = res
    }

    get progress(): number {
        return this.currentValue && this.targetValue ? Math.round((this.currentValue / this.targetValue) * 100) : 0
    }

    get health(): number {
        return this._health;
    }

    set health(value: number) {
        this._health = value
    }

    get cover() {
        return this.properties?.cover
    }

    set cover(value: Cover | undefined) {
        if (!this.properties) this.properties = new GoalProperties()
        this.properties.cover = value
    }

    get isDone(): boolean {
        switch (this.type) {
            case GoalType.CHECKBOX      : return this.currentValue === 1
            case GoalType.PARENT_GOAL   : return this.totalProgress === 100

            default                     : return !_.isNil(this.currentValue) && !_.isNil(this.targetValue) && this.currentValue >= this.targetValue
        }
    }

    set isDone(value:boolean) {
        switch (this.type) {
            case GoalType.CHECKBOX      :
                this.currentValue = value ? 1 : 0;
                this.updatedFields.add('currentValue')
                break

            default                     : /*do nothing*/
        }
    }

    // collect all parents until VISIBLE is found
    // all hidden parents breadcrumbs should be rendered here and VISIBLE one is rendered by itself
    get ghostParentGoals(): Goal[] {
        let res: Goal[] = []
        _.some(this.parentGoals.reverse(), goal=>{
            if ([RenderDisplay.VISIBLE, RenderDisplay.VISIBLE_GHOST].includes(goal.render.display)) return true
            res.unshift(goal)
        })
        return res
    }

    get parentGoals(): Goal[] {
        const parentGoals: Goal[] = []
        const getParentGoal = (goal: Goal) => {
            if (goal.parentGoal) {
                parentGoals.unshift(goal.parentGoal)
                getParentGoal(goal.parentGoal)
            }
        }

        getParentGoal(this)

        return parentGoals
    }

    get isRoot(): boolean {
        return this.rootGoalId === this.id
    }

    get isVisible(): boolean {
        return [RenderDisplay.VISIBLE, RenderDisplay.VISIBLE_GHOST].includes(this.render.display)
    }

    get hasSubGoals(): boolean {
        return !this.subGoals.isEmpty
    }

    get hasVisibleSubGoals(): boolean {
        return _.some(this.subGoals.models, model=>
            [RenderDisplay.VISIBLE, RenderDisplay.VISIBLE_GHOST].includes(model.render.display) ||
            model.hasVisibleSubGoals)
    }

    get hasNoDefaultTarget(): boolean {
        return [GoalType.CURRENCY, GoalType.COUNTER].includes(this._type)
    }

    get targetField(): FieldProto {
        switch (this._type) {
            case GoalType.CURRENCY:
                return FieldsFactory.get({
                    fieldId         : "targetValue",
                    type            : FieldType.CURRENCY,
                    isRequired      : true,
                    noValueOption   : false,
                    label           : "Target",
                    placeholder     : "Target"
                })
            case GoalType.COUNTER:
                return FieldsFactory.get({
                    fieldId         : "targetValue",
                    type            : FieldType.NUMBER,
                    isRequired      : true,
                    noValueOption   : false,
                    label           : "Target",
                    placeholder     : "Target"
                })
            default:
                return FieldsFactory.get({
                    fieldId         : "targetValue",
                    type            : FieldType.NUMBER,
                    isRequired      : true,
                    noValueOption   : false,
                    label           : "Target",
                    placeholder     : "Target"
                })
        }
    }

    /*get subGoalsAssigneeUserIds() {
        let res: ID[] = []

        _.map(this.subGoals?.models, (subGoal:Goal)=>{
            const allAssigneeUserIds = subGoal.allAssigneeUserIds
            if (allAssigneeUserIds) res = res.concat(allAssigneeUserIds)
        })

        return _.isEmpty(res) ? null : res
    }

    get allAssigneeUserIds() {
        let res: ID[] = []

        if (this.assigneeUserIds) res = res.concat(this.assigneeUserIds)
        const subGoalsRes = this.subGoalsAssigneeUserIds
        if (subGoalsRes) res = res.concat(subGoalsRes)

        return _.isEmpty(res) ? null : res
    }*/

    get isSimpleType() {
        return [GoalType.CURRENCY, GoalType.PERCENT, GoalType.COUNTER].includes(this._type)
    }

    get attachments():AttachmentsCollection {
        let res: any[] = []
        _.map(this.messages.models, (message: Message)=>{
            res = res.concat(message.attachments.models)
        })
        res = _.compact(res)

        debug && console.log(debug, "attachments", res)

        return new AttachmentsCollection(res)
    }

    validate(): ErrorProto[] | null {
        const errors: any[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.goal.name))

        if ([GoalType.COUNTER, GoalType.CURRENCY].includes(this._type)) {
            if (!this.targetValue) errors.push(new ErrorFieldRequired(gd.fields.goal.targetValue))
        }

        debug && console.log(debug, 'validate', this.id, errors)

        if (_.isEmpty(errors)) return null
        else return errors
    }

    _isSameValue(paramName:string, value:any) {
        // @ts-ignore
        const paramValue = this[paramName]
        if (Moment.isMoment(paramValue)) {
            // console.log("isSameValue", DatetimeUtils.momentToDate(this[paramName]), DatetimeUtils.dateTruncTime(value), DatetimeUtils.isSame(this[paramName], DatetimeUtils.dateToMoment(value), 'day'))
            return DatetimeUtils.isSame(paramValue, DatetimeUtils.dateToMoment(value), 'day')
        } else {
            return _.isEqual(paramValue,value)
        }
    }

    applyDelta(data:any, ignoreKeys: string[] = []) {
        let isChanged = false

        const ignoredParams = ['companyId', ...ignoreKeys]

        _.mapKeys(data, (value ,key)=>{
            if (ignoredParams.includes(key))  return

            switch (key) {
                case 'startDate':
                case 'endDate'  :
                    if (!this._isSameValue(key, value)) {
                        this[key] = toMomentDate(value)
                        isChanged = true
                    }
                    break

                case 'type':
                    if (!this._isSameValue(key, value)) {
                        this._type = value
                        isChanged = true
                    }
                    break

                case 'icon':
                    if (!this._isSameValue(key, value)) {
                        this._icon = value
                        isChanged = true
                    }
                    break

                case 'properties':
                    this.properties = new GoalProperties(value)
                    isChanged = true
                    break

                case 'messages':
                    this.messages = GoalMessagesCollection.initFromJson(value)
                    this.messages.setGoal(this)
                    this.messages.update()
                    isChanged = true
                    break

                case 'users':
                    this._users = GoalUsersCollection.initFromJSON(value)
                    isChanged = true
                    break

                default:
                    if (!this._isSameValue(key, value)) {
                        // @ts-ignore
                        this[key] = value
                        isChanged = true
                    }
            }

            debug && console.log(debug, "applyDelta", key, value, isChanged)
        })

        return isChanged
    }

    async save(): Promise<void> {
        const params: any = {}

        const parametersToSave = _.keys(this.toJSON())

        debug && console.log(debug, "save updatedFields", [...this.updatedFields], parametersToSave)

        // this is for universal update
        this.updatedFields.forEach((fieldName) => {
            // @ts-ignore
            debug && console.log(debug, "save fieldName", fieldName, this[fieldName])

            switch(fieldName) {
                case 'startDate'    :
                case 'endDate'      :
                    params[fieldName]   = toYYYYMMDD(this[fieldName])
                    break

                case 'iconWithColor':
                    params.icon         = this._icon
                    params.color        = this.color
                    break

                case 'cover'        :
                    params.cover        = this.cover?.toJSON() || null
                    break

                case 'users'        :
                    params.users        = this.users?.toJSON()
                    break

                default             :
                    // skip all local parameters
                    if (!parametersToSave.includes(fieldName)) return

                    // @ts-ignore
                    params[fieldName] = this[fieldName]
            }
        })

        this.updatedFields.clear()

        debug && console.log(debug, "save", this.id, params)

        if (!_.isEmpty(params)) ApiGoal.update(this.id, params)
    }

    toJSON() {
        return {
            id              : this.id,
            name            : this.name,
            icon            : this._icon,
            color           : this.color,
            users           : this._users ? this._users?.toJSON() : undefined,
            assigneeUserIds : this.assigneeUserIds,
            ownerUserIds    : this.ownerUserIds,
            projectId       : this.projectId,
            startDate       : toYYYYMMDD(this._startDate),
            endDate         : toYYYYMMDD(this._endDate),
            health          : this.health,
            // status          : this.status,
            type            : this._type,
            entityId        : this.entityId,
            currentValue    : this.currentValue,
            targetValue     : this.targetValue,
            descriptionRTF  : this.descriptionRTF,
            description     : this.description,
            externalLink    : this.externalLink,
            parentGoalId    : this.parentGoalId,
            properties      : this.properties?.toJSON(),
            messages        : this.messages?.toJSON(),
            isArchived      : this.isArchived,
        }
    }
}
